import { MidiaProdutoVitrine } from "@/components/vitrine/components/MidiaProdutoVitrine"
import { Device } from "@/components/vitrine/data/device"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { isDev } from "@/utils/enviroment-detector"
import { priceFormatter } from "@/utils/formatter"
import { getLinkProduto } from "@/utils/getLinkProduto"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import { BotaoComprarTimer } from "../../../components/BotaoComprarTimer"
import { FavoriteButton } from "@/components/vitrine/components/Favorite-button"

interface ProdutoPrincipalProps {
    hostImagem: string
    produtoDestaque: Produto
    precoPrincipal: number
    exibeValoresSomenteLogado: boolean
    blackfriday: boolean
    device: number
    validaTempoVitrine: boolean
    zordHintLoading: string
    vitrineButtonAddToCart: string
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
}

export function ProdutoPrincipal({
    hostImagem,
    produtoDestaque,
    precoPrincipal,
    exibeValoresSomenteLogado,
    blackfriday,
    device,
    validaTempoVitrine,
    zordHintLoading,
    vitrineButtonAddToCart,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine
}: Readonly<ProdutoPrincipalProps>){
    let percentualDescontoOferta = null
    let precoOferta = 0
    let iconPagamento = ''

    if (produtoDestaque.percentual_off && produtoDestaque.percentual_off > 0) {
        percentualDescontoOferta = produtoDestaque.percentual_off
    } else {
        percentualDescontoOferta = null
    }

    if (precoPrincipal == 1 && produtoDestaque.valor_boleto && produtoDestaque.valor_boleto > 0) {
        precoOferta = produtoDestaque.valor_boleto
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-boleto.svg')

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0 && percentualDescontoOferta == 0) {
            percentualDescontoOferta = (100 - (produtoDestaque.valor_boleto / produtoDestaque.valor_de * 100))
        }
    } else if (precoPrincipal == 2 && produtoDestaque.valor_cartao && produtoDestaque.valor_cartao[0] > 0) {
        precoOferta = produtoDestaque.valor_cartao[5] ? produtoDestaque.valor_cartao[5].valor : produtoDestaque.valor_cartao[1]
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-card.svg')

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0 && percentualDescontoOferta == 0) {
            percentualDescontoOferta = (100 - (precoOferta / produtoDestaque.valor_de * 100))
        }
    } else if (precoPrincipal == 4 && produtoDestaque.valor_pix && produtoDestaque.valor_pix > 0) {
        precoOferta = produtoDestaque.valor_pix
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-pix.svg')

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0 && percentualDescontoOferta == 0) {
            percentualDescontoOferta = (100 - (produtoDestaque.valor_pix / produtoDestaque.valor_de * 100))
        }
    }

    const hasOldPrice = Boolean(produtoDestaque.valor_de && produtoDestaque.valor_de > precoOferta && precoOferta > 0)
    const hasPrice = precoOferta > 0

    return (
        <div className="produto-principal product-card flex center justify-center">
            {exibeValoresSomenteLogado ? (
                <div>
                    <div className="box-img-produto-principal flex column">
                        <a href={getLinkProduto(produtoDestaque)} className={`${produtoDestaque.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                            <figure className={`box-img flex${utilizaFavoritosVitrine ? ' has-favorite-button' : ''}`}>
                                <MidiaProdutoVitrine
                                    hostImagem={hostImagem}
                                    produto={produtoDestaque}
                                    width={width}
                                    height={height}
                                    hoverImagensVitrine={hoverImagensVitrine}
                                    hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                />

                                {utilizaFavoritosVitrine && <FavoriteButton produto={produtoDestaque} />}
                            </figure>
                        </a>
                    </div>
                    <div className="box-info-oferta">
                        <a href={getLinkProduto(produtoDestaque)} className={`${produtoDestaque.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                            <h3 className="title-prd-oferta">{produtoDestaque.nome}</h3>
                        </a>

                        <div className="valores-logados-vitrine">
                            <span>
                                Faça login para ver os preços
                            </span>

                            <a href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`} className="btn-comprar-vitrine flex center justify-center">
                                Fazer login
                            </a>
                        </div>
                    </div>
                </div>
            ) : (
                <a href={getLinkProduto(produtoDestaque)} className={`${produtoDestaque.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                    <div className="box-img-produto-principal flex column">
                        <div className="area-topo-principal flex">
                            {(percentualDescontoOferta && percentualDescontoOferta > 0) && (
                                <div className="tag tag-desconto flex">
                                    <span className="icon-tag flex">
                                        <img
                                            className="lazyload lazyload-svg"
                                            src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'fire.svg') : zordHintLoading}
                                            data-src={getResourceFromS3('assets/global/blackfriday', 'fire.svg')}
                                            width="16"
                                            height="16"
                                            alt="Oferta Blackfriday"
                                            title="Oferta Blackfriday"
                                        />
                                    </span>
                                    <span className="tag-off">{Math.round(percentualDescontoOferta)}% OFF</span>
                                </div>
                            )}
                            
                            {(blackfriday && ![Device.MOBILE, Device.APP, Device.TABLET].includes(device)) && (
                                <div className="tag tag-black-friday flex">
                                    <span className="icon-tag flex">
                                        <img
                                            className="lazyload lazyload-svg"
                                            src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'fire.svg') : zordHintLoading}
                                            data-src={getResourceFromS3('assets/global/blackfriday', 'fire.svg')}
                                            width="16"
                                            height="16"
                                            alt="Oferta Blackfriday"
                                            title="Oferta Blackfriday"
                                        />
                                    </span>
                                    <span className="text-black">Restam poucas unidades</span>
                                </div>
                            )}
                        </div>

                        <figure className={`box-img flex${utilizaFavoritosVitrine ? ' has-favorite-button' : ''}`}>
                            <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produtoDestaque}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />

                            {utilizaFavoritosVitrine && <FavoriteButton produto={produtoDestaque} />}
                        </figure>
                    </div>
                    <div className="box-info-oferta">
                        <h3 className="title-prd-oferta">{produtoDestaque.nome}</h3>

                        <div className="flex center space-between">
                            <div className="price-oferta flex">
                                <div className={`icon-pagamento flex center${precoPrincipal == 4 && produtoDestaque.valor_pix && produtoDestaque.valor_pix > 0 ? ' icon-pagamento-pix' : ''}`}>
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? iconPagamento : zordHintLoading}
                                        data-src={iconPagamento}
                                        width="24"
                                        height="24"
                                        alt="Ícone pagamento"
                                        title="Ícone pagamento"
                                    />
                                </div>

                                <div className="flex column">
                                    {hasOldPrice && (
                                        <span className="old-price-oferta">De: {priceFormatter.format(produtoDestaque.valor_de)}</span>
                                    )}

                                    {hasPrice && (
                                        <span className="price">Por: {priceFormatter.format(precoOferta)}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <BotaoComprarTimer
                        produto={produtoDestaque}
                        validaTempoVitrine={validaTempoVitrine}
                        zordHintLoading={zordHintLoading}
                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                        device={device}
                    />
                </a>
            )}
        </div>
    )
}